module.exports = __webpack_public_path__ + "static/media/Belden.bbc67031.jpg";